export interface CrossSell {
  applicationId: number;
  organizationID: number;
  lenderCode: string;
  applicationCrossSellSummaryId: number;
  processStartTime: string;
  processEndTime: string;
  crossSellProcessingStatusTypeID: number;
  crossSellProcessingStatusType: string;
  newCreditOffers?: NewCreditOffersEntity[] | null;
  refinanceOpportunities?: NewCreditOffersEntity[] | null;
}

export interface NewCreditOffersEntity {
  applicationCrossSellDetailId: number;
  tradeLinePK: number;
  loanTypeID: number;
  loanType: string;
  crossSellDecisionSuccess: boolean;
  decisionAmount: number;
  decisionTerm: number;
  decisionRate: number;
  decisionTier: string;
  decisionResult: string;
  estimatedPayment: number;
  message: string;
  createdOn: string;
  hasRoutingException: boolean;
  hasOtherException: boolean;
  creditor: string;
  balance?: null;
  term?: null;
  payment?: null;
  description: string;
  expirationDate?: null;
  crossSellStatusID: number;
  crossSellStatusDescription: string;
  expirationText: string;
  decisionResponseDocRepID: number;
  newApplicationID?: null;
  lenderLoanProductGUID: string;
  lenderLoanProductName: string;
  isRevolving: boolean;
  remainingTerm?: null;
  totalFinanceRemaining?: null;
  originalRate?: null;
  totalFinance?: null;
  estimatedMonthlySavings?: null;
  totalSavings?: null;
  originalAmount?: null;
  lender?: null;
  creditReportDocRepID?: null;
  hasManualDecision: boolean;
  loanOfficerGUID?: null;
  loanOfficerName?: null;
  openDate?: null;
  originalPayment?: null;
  tradeLineAccountCategoryTypeID?: null;
  tradeLineID?: null;
  originatingAmount?: null;
  originatingPayment?: null;
  originatingStageID?: null;
  originatingStatusID?: null;
  approvalAuthorityLevelNumber?: null;
  approvalAuthorityLevelName?: null;
  approvalAuthorityLevelCode?: null;
  isCoApplicantIncluded: boolean;
  stipulation: string;
  documentLinkDisplayText: string;
  termsAndConditions: string;
  docRepID: string;
  headline: string;
  subtitle: string;
}

export interface CrossSellOfferDetails {
  applicationId: number;
  offers?: OffersEntity[] | null;
}
export interface OffersEntity {
  isSuccess: boolean;
  errorMessage: string;
  applicationCrossSellDetailID: number;
  term: number;
  rate: number;
  amount: number;
  tier: string;
  note: string;
  description: string;
  successCallBack?: () => void;
}

export interface CrossSellStatusUpdate {
  applicationId: string;
  applicationCrossSellDetailIDs: number[];
}

export enum CrossSellRequireModule {
  Dashboard = 'Dashboard',
  OAOPostApp = 'OAOPostApp',
  OLAPostApp = 'OLAPostApp'
}
